let customOrder = require('../../../actions/custom-order');
let error = require('../../../actions/error');
let currentOrder = require('../../../actions/account/current-order');
let orders = require('../../../actions/account/orders');
let utils = require('../../../actions/utils');
let { restoreStateGroup } = require('../custom-order/index');

module.exports = {
    initSelectedParamsFromOrderGroup: [
        [
            currentOrder.getSelectedParamsFromCurrentOrder,
            {
                success: [
                    ...restoreStateGroup
                ],
                error: [
                    error.internalError('currentOrder.getSelectedParamsFromCurrentOrder')
                ]
            }
        ]
    ],

    saveSelectedParamsGroup: [
        [
            currentOrder.updateSelectedParamsForCurrentOrder,
            {
                success: [
                    currentOrder.updateOrder(['price', 'paymentTypeId', 'necessaryDocuments', 'selectedParameters']),
                    ...restoreStateGroup,
                    orders.setDataChangedConfirmed
                ],
                error: [
                    error.internalError('currentOrder.updateSelectedParamsForCurrentOrder')
                ]
            }
        ]
    ],

    setUserGroup: [
        [
            orders.setUser,
            {
                success: [
                    currentOrder.updateOrder(['user', 'necessaryDocuments']),
                    utils.unset(['account', 'orders', 'currentOrder', 'localChanges', 'selectedUser']),
                    utils.set(['account', 'orders', 'currentOrder', 'tooltips', 'showUserMustBeSelected'], false)
                ],
                error: []
            }
        ]
    ]
};



// WEBPACK FOOTER //
// ./signals/groups/account/current-order.js